import { createContext, useContext } from "react";
import { useTranslation } from "react-i18next";

import { IconButton } from "../primitives/IconButton";
import type { UiTheme } from "../theme";

// PG-57: the ▲ that closes an open collapsible Progress widget. It sits at the
// end of the panel's own title row (Antenore 28/09), so the panels do not
// know about it: ProgressCollapsibleWidget provides the context, and
// WidgetTitleRow (inside PanelTitleRow and the cards without a help pill)
// renders this button. Anywhere else (Home, the coach, a widget the layout
// shows expanded) there is no context and it renders nothing.
type WidgetCollapse = { label: string; onCollapse: () => void };

export const WidgetCollapseContext = createContext<WidgetCollapse | null>(null);

export function WidgetCollapseButton({ theme }: { theme: UiTheme }) {
  const { t } = useTranslation();
  const collapse = useContext(WidgetCollapseContext);
  if (!collapse) return null;
  return (
    <IconButton
      theme={theme}
      variant="bare"
      name="chevron-up"
      expanded
      onPress={collapse.onCollapse}
      accessibilityLabel={t("mobile.widgetConfig.collapse", {
        name: collapse.label,
        defaultValue: "Collapse {{name}}",
      })}
    />
  );
}
